import React from 'react';
import { Card } from 'antd';

const { Meta } = Card;

type CardProps = {
  name: string;
};

function CarouselCard({ name }: CardProps) {
  return (
    <Card
      hoverable
      cover={
        <img
          style={{ height: 160, objectFit: 'cover', padding: 10 }}
          alt="example"
          src={name}
        />
      }
      className="carousel-card"
    >
      <Meta
        title="Food Den"
        description="Continental, Indian, Pan-Asian, Oriental"
      />
    </Card>
  );
}

export default CarouselCard;
